/**
 * Tracks whether a live meeting WebSocket is currently open.
 *
 * Deliberately a plain module rather than React context: the auth layer
 * (AuthContext.refreshTokenIfStale and apiService's error handler) needs to read
 * this from outside the React tree — both run on timers/interceptors where a
 * hook isn't available.
 *
 * Exists so a session teardown can be deferred instead of dropping a rep
 * out of a call in progress. See the 2026-09-03 staging incident: users were
 * force-logged-out mid-meeting when silent token refresh failed.
 */
let meetingActive = false;

/** Called by the meeting UI on WebSocket open/close. */
export const setMeetingActive = (active) => {
  meetingActive = !!active;
};

/** True while a meeting WebSocket is connected. */
export const isMeetingActive = () => meetingActive;
